export default __webpack_public_path__ + "assets/22a9d0e29bb577d1c4f1ed795975c16f.svg";